export const VERSION = {
  NAME: 'v1.0.0',
  DATE: '2022-06-23 18:30',
  ENV: process.env.REACT_APP_ENVIRONMENT || 'unknown',
  IS_TEST: process.env.REACT_APP_ENVIRONMENT !== 'prod'
};
